import { useStoreMap } from 'effector-react'
import type React from 'react'

import { css, cx } from '@portal/styled-system/css'

import { EmailInput } from '@/shared/ui/input-v2/email'
import { PasswordInput } from '@/shared/ui/input-v2/password'

import * as model from './model'

const inputChanged = model.fieldUpdated.prepend((event: React.ChangeEvent<HTMLInputElement>) => ({
    key: event.target.name,
    value: event.target.value,
}))

// TODO: DRY
export function EmailInputField(props: Omit<React.ComponentProps<typeof EmailInput>, 'onChange' | 'value'>) {
    const value = useStoreMap({
        store: model.$form,
        keys: ['email'],
        fn: (values) => values['email'] ?? '',
    })

    return <EmailInput {...props} onChange={inputChanged} value={value} />
}

export function PasswordInputField(
    props: Omit<React.ComponentProps<typeof PasswordInput>, 'onChange' | 'value'> & { name: string }
) {
    const value = useStoreMap({
        store: model.$form,
        keys: [props.name],
        fn: (values) => values[props.name] ?? '',
    })

    return (
        <PasswordInput
            {...props}
            onChange={inputChanged}
            value={value}
            startDecorator={
                <div
                    className={css({
                        width: '[2.375rem]',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    })}
                >
                    <i className={cx('fa-solid fa-lock', css({ fontSize: 'md' }))} />
                </div>
            }
        />
    )
}
